import { render } from "./gsalesPage.vue?vue&type=template&id=15245000"
import script from "./gsalesPage.vue?vue&type=script&lang=js"
export * from "./gsalesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__